import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import languages from 'constants/languages';
import translations from 'locales';
var format = function (value, format, lng) {
    if (lng === void 0) { lng = 'ar'; }
    if (format === 'money') {
        return Number(value)
            .toFixed(2)
            .replace(/\d(?=(\d{3})+\.)/g, '$&,') + ' E£';
    }
    return value.toString();
};
export var isRtlLanguage = function (lng) {
    return (lng || '').toLowerCase().startsWith(languages.AR);
};
export var getUiDirection = function (lng) {
    return isRtlLanguage(lng) ? 'rtl' : 'ltr';
};
/** Sync html/body dir + lang so CSS `[dir='rtl']` rules and browser layout flip. */
export var applyUiDirection = function (lng) {
    var language = lng || languages.EN;
    var direction = getUiDirection(language);
    var root = document.documentElement;
    root.setAttribute('dir', direction);
    root.setAttribute('lang', language);
    if (document.body) {
        document.body.setAttribute('dir', direction);
    }
};
export var i18nSetup = function (lng) {
    if (lng === void 0) { lng = languages.EN; }
    var language = lng || languages.EN;
    if (i18n.isInitialized) {
        if (i18n.language !== language) {
            void i18n.changeLanguage(language);
        }
    }
    else {
        i18n.use(initReactI18next).init({
            resources: translations,
            lng: language,
            fallbackLng: languages.EN,
            interpolation: {
                format: format
            }
        });
    }
    applyUiDirection(language);
};
